import { createLink, LinkComponent, useNavigate } from '@tanstack/react-router';
import * as React from 'react';

interface MousedownLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  // Add any additional props you want to pass to the anchor element
}

const InnerMouseDownLink = React.forwardRef<HTMLAnchorElement, MousedownLinkProps>((props, ref) => {
  const navigate = useNavigate();
  return (
    <a
      ref={ref}
      {...props}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate({ to: props.href });
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    />
  );
});

const WrappedLink = createLink(InnerMouseDownLink);

export const MousedownLink: LinkComponent<typeof InnerMouseDownLink> = (props) => {
  return <WrappedLink preload={'intent'} {...props} />;
};
